"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get parseMetaProp () {
        return parseMetaProp;
    },
    get prepareForDb () {
        return prepareForDb;
    },
    get prepareForResponse () {
        return prepareForResponse;
    },
    get stringifyMetaProp () {
        return stringifyMetaProp;
    },
    get validateImportSchema () {
        return validateImportSchema;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function parseMetaProp(model, propName = 'meta', fallbackValue = {}) {
    if (!model) return;
    // parse meta property
    try {
        return typeof model[propName] === 'string' ? JSON.parse(model[propName]) : model[propName];
    } catch (unused) {
        return fallbackValue;
    }
}
function stringifyMetaProp(model, propName = 'meta', fallbackValue = '{}') {
    if (!model) return null;
    // stringify meta property
    try {
        return typeof model[propName] === 'string' || model[propName] === null ? model[propName] : JSON.stringify(model[propName]);
    } catch (e) {
        return fallbackValue;
    }
}
function prepareForDb(model, props = 'meta') {
    if (!model) return model;
    if (typeof props === 'string') {
        props = [
            props
        ];
    }
    props.forEach((prop)=>{
        if (prop in model) {
            model[prop] = stringifyMetaProp(model, prop);
        }
    });
    return model;
}
function prepareForResponse(model, props = 'meta') {
    if (!model) return model;
    if (typeof props === 'string') {
        props = [
            props
        ];
    }
    props.forEach((prop)=>{
        if (prop in model) {
            model[prop] = parseMetaProp(model, prop);
        }
    });
    return model;
}
async function validateImportSchema(context, data) {
    // validate table names
    if (data.some((each)=>!each.model.title && !each.model.table_name)) {
        _ncError.NcError.get(context).invalidRequestBody('Missing table `title` property in request body');
    }
    const modelNamedData = data.map((each)=>{
        var _each_model_title, _each_model_table_name;
        return _extends({}, each, {
            model: _extends({}, each.model, {
                title: (_each_model_title = each.model.title) != null ? _each_model_title : each.model.table_name,
                table_name: (_each_model_table_name = each.model.table_name) != null ? _each_model_table_name : each.model.title
            })
        });
    });
    const aliasDuplicate = (0, _nocodbsdk.arrGetDuplicate)(modelNamedData.map((each)=>each.model.title));
    if (aliasDuplicate) {
        _ncError.NcError.get(context).duplicateAlias({
            alias: aliasDuplicate,
            base: context.base_id,
            type: 'table'
        });
    }
    const tableNameDuplicate = (0, _nocodbsdk.arrGetDuplicate)(modelNamedData.map((each)=>each.model.table_name));
    if (tableNameDuplicate) {
        _ncError.NcError.get(context).duplicateAlias({
            alias: tableNameDuplicate,
            base: context.base_id,
            type: 'table',
            label: 'name'
        });
    }
    return modelNamedData;
}
